import useSWR from "swr"

import { apiBookingClient } from "services/apiBookingClient"
import { selectUser } from "stores/auth/authSlice"
import { useAppSelector } from "stores/hooks"

const fetcher = async () => {
  const response = await apiBookingClient.getListOfPromocodes()
  return response.data.body.promocodes || []
}

const useListOfPromocodes = () => {
  const currentUser = useAppSelector(selectUser)

  return useSWR(
    currentUser ? { url: "/api/getListOfPromocodes" } : null,
    fetcher,
    {
      loadingTimeout: 15000,
      keepPreviousData: true,
      revalidateOnFocus: false,
      dedupingInterval: 3000,
      errorRetryCount: 3,
    },
  )
}

export default useListOfPromocodes
